import { useState, useEffect, useContext } from "react";

import { customHistory } from "../../../custom-browser-router";
import MessageBanner from "../../../shared/components/message-banner/message-banner";
import { roleAdmin, roleRead, roleWrite } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import { IOnboardingAllData } from "../../../shared/context/auth-context";

import "./home.scss";
import { getAnalyticsUrl, getManagerUrl } from "@/config";

// export interface IlicensesBannerData {
//   datasets_licenses_expire_soon: ITableRowData[]
//   is_platfrom_license_active: boolean | undefined; 
// }

const Home = () => {
  const [notificationData, setNotificationData] = useState<JSX.Element[]>([]);
  const [unblockInput, setUnblockInput] = useState(false);
  
  const authCtx = useContext(AuthContext);

  const [, setDatamodelBanner] = useState(false);
  const [, setDatamodelBannerHeight] = useState(0);
  const hasManager = getManagerUrl() !== "";
  const hasAnalytics = getAnalyticsUrl() !== "";

  // const [licensesBannerData, setLicensesBannerData] = useState<IlicensesBannerData>({datasets_licenses_expire_soon: [], is_platfrom_license_active: undefined});

  // const { sendRequest: getDatasetLicensesSortBy, status: getDatasetLicensesSortByStatus, data: getDatasetLicensesSortByData, error: getDatasetLicensesSortByError } = useHttpNonTable(getAllDataNonTable, true, authCtx.token);
  // const { sendRequest: getPlatformLicensesSortBy, status: getPlatformLicensesSortByStatus, data: getPlatformLicensesSortByData, error: getPlatformLicensesSortByError } = useHttpNonTable(getAllDataNonTable, true, authCtx.token);

  // const defineStatus = (data: ITableRowData[]) => {
  //   let atLeastOneActive = false;
  //   let allTheSoonExpiringOnes: ITableRowData[] = [];
  //   // with platform licenses, if at least one licenses is Active that means we don't want to show the expiration msg bcs it can be an old one,
  //   // bcs we concatinate platform licenses anyway
  //   data.forEach((row: ITableRowData) => {
  //     if (new Date(new Date().getTime() + 2628000000) > new Date(new Date(row.expiration_date).getTime())) {
  //       // (today + 1 month) > x.expiration_date => expires soon
  //       allTheSoonExpiringOnes = [...allTheSoonExpiringOnes, row];
  //     }
  //     if (new Date(new Date().getTime() + 2628000000) < new Date(new Date(row.expiration_date).getTime())) {
  //       // (today + 1 month) < x.expiration_date => active
  //       atLeastOneActive = true;
  //     }
  //   });
  //   return { atLeastOneActive, allTheSoonExpiringOnes };
  // };

  // useEffect(() => {
  //   if ( getDatasetLicensesSortByStatus === "completed" && !getDatasetLicensesSortByError && getPlatformLicensesSortByStatus === "completed" && !getPlatformLicensesSortByError) {
  //     const platformLicensesResults = defineStatus(getPlatformLicensesSortByData.rows);
  //     const datasetslicensesResults = defineStatus(getDatasetLicensesSortByData.rows);

  //     if (platformLicensesResults && datasetslicensesResults) {
  //       setLicensesBannerData({
  //         datasets_licenses_expire_soon: datasetslicensesResults.allTheSoonExpiringOnes,
  //         is_platfrom_license_active: platformLicensesResults.atLeastOneActive
  //       });
  //     }
  //   }
  // }, [getDatasetLicensesSortByStatus, getPlatformLicensesSortByStatus]);

  // useEffect(() => {
  //   getDatasetLicensesSortBy("licenses/dataset");
  //   getPlatformLicensesSortBy("licenses/platform");
  // }, []);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleAdmin) !== -1) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    const allOnboardingData: IOnboardingAllData = { ...authCtx.onboardingAnalyticsData, ...authCtx.onboardingPlatformData, ...authCtx.onboardingManagerData };
    const allNotifications = [];
    if (hasAnalytics) {
      for (const property in allOnboardingData) {
        if (allOnboardingData[property] === 0) {
          switch (property) {
            case "event":
              allNotifications.push(<span key={property} className="home-onboardingMsg" onClick={() => customHistory.push("/events/new")}>event type +</span>);
              break;
            case "entity":
              allNotifications.push(<span key={property} className="home-onboardingMsg" onClick={() => customHistory.push("/entities/new")}>entity type +</span>);
              break;
            case "dataset":
              allNotifications.push(<span key={property} className="home-onboardingMsg" onClick={() => customHistory.push("/analytics/datasets-edit")}>dataset +</span>);
              break;
            case "tmsconfig":
              allNotifications.push(<span key={property} className="home-onboardingMsg" onClick={() => customHistory.push("/analytics/transaction-monitoring-system-config/new")}>tms config +</span>);
              break;
            case "runmodeconfig":
              allNotifications.push(<span key={property} className="home-onboardingMsg" onClick={() => customHistory.push("/run-mode-configuration")}>run mode config +</span>);
              break;
            case "modelconfig":
              allNotifications.push(<span key={property} className="home-onboardingMsg" onClick={() => customHistory.push("/analytics/datasets")}>models +</span>);
              break;
          }
        }
      }
      setNotificationData(allNotifications);
    }
  }, [authCtx.onboardingAnalyticsData, authCtx.onboardingPlatformData, authCtx.onboardingManagerData]);

  const getBannerStatus = () => {
    setDatamodelBanner(true);
  };

  const getBannerHeight = (val: number) => {
    setDatamodelBannerHeight(val);
  };

  const rolesArray = authCtx.selectedTenant.roles;
  const hasReadOrWrite = rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleRead) !== -1;

  return (
    <div className="home">
      <div className="home-wrapper">
        {unblockInput && notificationData.length !== 0 && (
          <MessageBanner getBannerHeight={getBannerHeight} getBannerStatus={getBannerStatus}>
            <span className="home-onboardingNote">
              To start generating models, please make sure to create and setup:
              <span className="home-menu-tab-status-red"></span>
            </span>
            {notificationData.map((notification) => notification)}
          </MessageBanner>
        )}

        {hasManager && hasReadOrWrite &&<div className="home-dashboard-container">
          <h3 className="home-dashboard-title">Quick Access to AlertCases</h3>
          <div className="home-button-grid">
            <button onClick={() => customHistory.push("/manager/alertcases#open_active_alertcases")} className="home-dashboard-btn">
              Open / Active AlertCases
            </button>
            <button onClick={() => customHistory.push("/manager/alertcases#personal_alertcases")} className="home-dashboard-btn">
              Personal AlertCases
            </button>
            <button onClick={() => customHistory.push("/manager/alertcases#aggregator_alertcases")} className="home-dashboard-btn">
              Aggregator AlertCases
            </button>
            <button onClick={() => customHistory.push("/manager/alertcases#finished_alertcases")} className="home-dashboard-btn">
              Finished AlertCases
            </button>
            <button onClick={() => customHistory.push("/manager/alertcases#all_alertcases")} className="home-dashboard-btn">
              All AlertCases
            </button>
            <button onClick={() => customHistory.push("/manager/advanced-search")} className="home-dashboard-btn">
              Advanced Search
            </button>
          </div>
        </div>
        }

        {/* {(authCtx.systemAdmin && getDatasetLicensesSortByData && getPlatformLicensesSortByData && (licensesBannerData.datasets_licenses_expire_soon.length !== 0 || !licensesBannerData.is_platfrom_license_active)) &&
        <MessageBanner heightProp={datamodelBanner ? 0 : datamodelBannerHeight}>
          <span className="home-onboardingNote">
            The following licenses are soon to be expired:
            <span className="home-menu-tab-status-red"></span>
          </span>
          {!licensesBannerData.is_platfrom_license_active &&
          <span className="home-onboardingMsg" onClick={() => customHistory.push(`/licenses`)}>
            Platform license
          </span>}
          {licensesBannerData.datasets_licenses_expire_soon.length !== 0 && licensesBannerData.datasets_licenses_expire_soon.map((license:ITableRowData, i: number) => {
            return (
              <span key={i} className="home-onboardingMsg" onClick={() => customHistory.push(`/licenses`)}>
                {license.name}
              </span>
            );
          })}
        </MessageBanner>} */}
      </div>
    </div>
  );
};

export default Home;

